export default "__VITE_ASSET__f3431763__"